"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.WarningType = exports.VonageSourceType = exports.PipelineInfoData = exports.MediaProcessorConnector = exports.MediaProcessor = exports.ErrorFunction = void 0;
exports.getVonageMetadata = C;
exports.isSupported = ve;
exports.setVonageMetadata = Ce;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _globalThis = function (Object) {
  function get() {
    var _global = this || self;
    delete Object.prototype.__magic__;
    return _global;
  }
  if (typeof globalThis === "object") {
    return globalThis;
  }
  if (this) {
    return get();
  } else {
    Object.defineProperty(Object.prototype, "__magic__", {
      configurable: true,
      get: get
    });
    var _global = __magic__;
    return _global;
  }
}(Object);
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var V = Object.defineProperty;
var Y = (t, e, r) => e in t ? V(t, e, {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: r
}) : t[e] = r;
var a = (t, e, r) => (Y(t, typeof e != "symbol" ? e + "" : e, r), r);
function ve() {
  return new Promise((t, e) => {
    typeof MediaStreamTrackProcessor > "u" || typeof MediaStreamTrackGenerator > "u" ? e("Your browser does not support the MediaStreamTrack API for Insertable Streams of Media.") : t();
  });
}
let l = function l() {};
a(l, "updates", {
  transformer_new: "New transformer",
  transformer_null: "Null transformer"
}), a(l, "errors", {
  transformer_none: "No transformers provided",
  transformer_start: "Cannot start transformer",
  transformer_transform: "Cannot transform frame",
  transformer_flush: "Cannot flush transformer",
  readable_null: "Readable is null",
  writable_null: "Writable is null"
});
const h = /* @__PURE__ */new WeakMap(),
  E = /* @__PURE__ */new WeakMap(),
  y = /* @__PURE__ */new WeakMap(),
  O = Symbol("anyProducer"),
  U = Promise.resolve(),
  k = Symbol("listenerAdded"),
  A = Symbol("listenerRemoved");
let x = !1;
function g(t) {
  if (typeof t != "string" && typeof t != "symbol") throw new TypeError("eventName must be a string or a symbol");
}
function T(t) {
  if (typeof t != "function") throw new TypeError("listener must be a function");
}
function _(t, e) {
  const r = E.get(t);
  return r.has(e) || r.set(e, /* @__PURE__ */new Set()), r.get(e);
}
function b(t, e) {
  const r = typeof e == "string" || typeof e == "symbol" ? e : O,
    s = y.get(t);
  return s.has(r) || s.set(r, /* @__PURE__ */new Set()), s.get(r);
}
function q(t, e, r) {
  const s = y.get(t);
  if (s.has(e)) {
    for (var _iterator = _createForOfIteratorHelperLoose(s.get(e)), _step; !(_step = _iterator()).done;) {
      const o = _step.value;
      o.enqueue(r);
    }
  }
  if (s.has(O)) {
    const o = Promise.all([e, r]);
    for (var _iterator2 = _createForOfIteratorHelperLoose(s.get(O)), _step2; !(_step2 = _iterator2()).done;) {
      const i = _step2.value;
      i.enqueue(o);
    }
  }
}
function $(t, e) {
  e = Array.isArray(e) ? e : [e];
  let r = !1,
    s = () => {},
    o = [];
  const i = {
    enqueue(n) {
      o.push(n), s();
    },
    finish() {
      r = !0, s();
    }
  };
  for (var _iterator3 = _createForOfIteratorHelperLoose(e), _step3; !(_step3 = _iterator3()).done;) {
    const n = _step3.value;
    b(t, n).add(i);
  }
  return {
    next() {
      var _this = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!o) {
                _context.next = 20;
                break;
              }
              if (!(o.length === 0)) {
                _context.next = 12;
                break;
              }
              if (!r) {
                _context.next = 6;
                break;
              }
              _context.t2 = (o = void 0, _this.next());
              _context.next = 9;
              break;
            case 6:
              _context.next = 8;
              return new Promise(n => {
                s = n;
              });
            case 8:
              _context.t2 = _this.next();
            case 9:
              _context.t1 = _context.t2;
              _context.next = 17;
              break;
            case 12:
              _context.t3 = !1;
              _context.next = 15;
              return o.shift();
            case 15:
              _context.t4 = _context.sent;
              _context.t1 = {
                done: _context.t3,
                value: _context.t4
              };
            case 17:
              _context.t0 = _context.t1;
              _context.next = 21;
              break;
            case 20:
              _context.t0 = {
                done: !0
              };
            case 21:
              return _context.abrupt("return", _context.t0);
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    return(n) {
      var _arguments = arguments;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _iterator4, _step4, c;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              o = void 0;
              for (_iterator4 = _createForOfIteratorHelperLoose(e); !(_step4 = _iterator4()).done;) {
                c = _step4.value;
                b(t, c).delete(i);
              }
              s();
              if (!(_arguments.length > 0)) {
                _context2.next = 11;
                break;
              }
              _context2.t1 = !0;
              _context2.next = 7;
              return n;
            case 7:
              _context2.t2 = _context2.sent;
              _context2.t0 = {
                done: _context2.t1,
                value: _context2.t2
              };
              _context2.next = 12;
              break;
            case 11:
              _context2.t0 = {
                done: !0
              };
            case 12:
              return _context2.abrupt("return", _context2.t0);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    [Symbol.asyncIterator]() {
      return this;
    }
  };
}
function H(t) {
  if (t === void 0) return Q;
  if (!Array.isArray(t)) throw new TypeError("`methodNames` must be an array of strings");
  for (var _iterator5 = _createForOfIteratorHelperLoose(t), _step5; !(_step5 = _iterator5()).done;) {
    const e = _step5.value;
    if (!Q.includes(e)) throw typeof e != "string" ? new TypeError("`methodNames` element must be a string") : new Error(`${e} is not Emittery method`);
  }
  return t;
}
const I = t => t === k || t === A;
let m = /*#__PURE__*/function () {
  m.mixin = function mixin(e, r) {
    return r = H(r), s => {
      if (typeof s != "function") throw new TypeError("`target` must be function");
      for (var _iterator6 = _createForOfIteratorHelperLoose(r), _step6; !(_step6 = _iterator6()).done;) {
        const n = _step6.value;
        if (s.prototype[n] !== void 0) throw new Error(`The property \`${n}\` already exists on \`target\``);
      }
      function o() {
        return Object.defineProperty(this, e, {
          enumerable: !1,
          value: new m()
        }), this[e];
      }
      Object.defineProperty(s.prototype, e, {
        enumerable: !1,
        get: o
      });
      const i = n => function () {
        return this[e][n](...arguments);
      };
      for (var _iterator7 = _createForOfIteratorHelperLoose(r), _step7; !(_step7 = _iterator7()).done;) {
        const n = _step7.value;
        Object.defineProperty(s.prototype, n, {
          enumerable: !1,
          value: i(n)
        });
      }
      return s;
    };
  };
  function m(e) {
    if (e === void 0) {
      e = {};
    }
    h.set(this, /* @__PURE__ */new Set()), E.set(this, /* @__PURE__ */new Map()), y.set(this, /* @__PURE__ */new Map()), this.debug = e.debug || {}, this.debug.enabled === void 0 && (this.debug.enabled = !1), this.debug.logger || (this.debug.logger = (r, s, o, i) => {
      try {
        i = JSON.stringify(i);
      } catch (_unused) {
        i = `Object with the following keys failed to stringify: ${Object.keys(i).join(",")}`;
      }
      typeof o == "symbol" && (o = o.toString());
      const n = new Date(),
        c = `${n.getHours()}:${n.getMinutes()}:${n.getSeconds()}.${n.getMilliseconds()}`;
      console.log(`[${c}][emittery:${r}][${s}] Event Name: ${o}
	data: ${i}`);
    });
  }
  var _proto = m.prototype;
  _proto.logIfDebugEnabled = function logIfDebugEnabled(e, r, s) {
    (m.isDebugEnabled || this.debug.enabled) && this.debug.logger(e, this.debug.name, r, s);
  };
  _proto.on = function on(e, r) {
    T(r), e = Array.isArray(e) ? e : [e];
    for (var _iterator8 = _createForOfIteratorHelperLoose(e), _step8; !(_step8 = _iterator8()).done;) {
      const s = _step8.value;
      g(s), _(this, s).add(r), this.logIfDebugEnabled("subscribe", s, void 0), I(s) || this.emit(k, {
        eventName: s,
        listener: r
      });
    }
    return this.off.bind(this, e, r);
  };
  _proto.off = function off(e, r) {
    T(r), e = Array.isArray(e) ? e : [e];
    for (var _iterator9 = _createForOfIteratorHelperLoose(e), _step9; !(_step9 = _iterator9()).done;) {
      const s = _step9.value;
      g(s), _(this, s).delete(r), this.logIfDebugEnabled("unsubscribe", s, void 0), I(s) || this.emit(A, {
        eventName: s,
        listener: r
      });
    }
  };
  _proto.once = function once(e) {
    return new Promise(r => {
      const s = this.on(e, o => {
        s(), r(o);
      });
    });
  };
  _proto.events = function events(e) {
    e = Array.isArray(e) ? e : [e];
    for (var _iterator10 = _createForOfIteratorHelperLoose(e), _step10; !(_step10 = _iterator10()).done;) {
      const r = _step10.value;
      g(r);
    }
    return $(this, e);
  };
  _proto.emit = /*#__PURE__*/function () {
    var _emit = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(e, r) {
      var s, o, i, n;
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            g(e), this.logIfDebugEnabled("emit", e, r), q(this, e, r);
            s = _(this, e), o = h.get(this), i = [...s], n = I(e) ? [] : [...o];
            _context5.next = 4;
            return U;
          case 4:
            _context5.next = 6;
            return Promise.all([...i.map( /*#__PURE__*/function () {
              var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(c) {
                return _regenerator.default.wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      if (!s.has(c)) {
                        _context3.next = 2;
                        break;
                      }
                      return _context3.abrupt("return", c(r));
                    case 2:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }));
              return function (_x3) {
                return _ref.apply(this, arguments);
              };
            }()), ...n.map( /*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(c) {
                return _regenerator.default.wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      if (!o.has(c)) {
                        _context4.next = 2;
                        break;
                      }
                      return _context4.abrupt("return", c(e, r));
                    case 2:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              }));
              return function (_x4) {
                return _ref2.apply(this, arguments);
              };
            }())]);
          case 6:
          case "end":
            return _context5.stop();
        }
      }, _callee5, this);
    }));
    function emit(_x, _x2) {
      return _emit.apply(this, arguments);
    }
    return emit;
  }();
  _proto.emitSerial = /*#__PURE__*/function () {
    var _emitSerial = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(e, r) {
      var s, o, i, n, _i2, _i, c, _i3, _n;
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            g(e), this.logIfDebugEnabled("emitSerial", e, r);
            s = _(this, e), o = h.get(this), i = [...s], n = [...o];
            _context6.next = 4;
            return U;
          case 4:
            _i2 = 0, _i = i;
          case 5:
            if (!(_i2 < _i.length)) {
              _context6.next = 14;
              break;
            }
            c = _i[_i2];
            _context6.t0 = s.has(c);
            if (!_context6.t0) {
              _context6.next = 11;
              break;
            }
            _context6.next = 11;
            return c(r);
          case 11:
            _i2++;
            _context6.next = 5;
            break;
          case 14:
            _i3 = 0, _n = n;
          case 15:
            if (!(_i3 < _n.length)) {
              _context6.next = 24;
              break;
            }
            c = _n[_i3];
            _context6.t1 = o.has(c);
            if (!_context6.t1) {
              _context6.next = 21;
              break;
            }
            _context6.next = 21;
            return c(e, r);
          case 21:
            _i3++;
            _context6.next = 15;
            break;
          case 24:
          case "end":
            return _context6.stop();
        }
      }, _callee6, this);
    }));
    function emitSerial(_x5, _x6) {
      return _emitSerial.apply(this, arguments);
    }
    return emitSerial;
  }();
  _proto.onAny = function onAny(e) {
    return T(e), this.logIfDebugEnabled("subscribeAny", void 0, void 0), h.get(this).add(e), this.emit(k, {
      listener: e
    }), this.offAny.bind(this, e);
  };
  _proto.anyEvent = function anyEvent() {
    return $(this);
  };
  _proto.offAny = function offAny(e) {
    T(e), this.logIfDebugEnabled("unsubscribeAny", void 0, void 0), this.emit(A, {
      listener: e
    }), h.get(this).delete(e);
  };
  _proto.clearListeners = function clearListeners(e) {
    e = Array.isArray(e) ? e : [e];
    for (var _iterator11 = _createForOfIteratorHelperLoose(e), _step11; !(_step11 = _iterator11()).done;) {
      const r = _step11.value;
      if (this.logIfDebugEnabled("clear", r, void 0), typeof r == "string" || typeof r == "symbol") {
        _(this, r).clear();
        const s = b(this, r);
        for (var _iterator12 = _createForOfIteratorHelperLoose(s), _step12; !(_step12 = _iterator12()).done;) {
          const o = _step12.value;
          o.finish();
        }
        s.clear();
      } else {
        h.get(this).clear();
        for (var _iterator13 = _createForOfIteratorHelperLoose(E.get(this).values()), _step13; !(_step13 = _iterator13()).done;) {
          const s = _step13.value;
          s.clear();
        }
        for (var _iterator14 = _createForOfIteratorHelperLoose(y.get(this).values()), _step14; !(_step14 = _iterator14()).done;) {
          const s = _step14.value;
          for (var _iterator15 = _createForOfIteratorHelperLoose(s), _step15; !(_step15 = _iterator15()).done;) {
            const o = _step15.value;
            o.finish();
          }
          s.clear();
        }
      }
    }
  };
  _proto.listenerCount = function listenerCount(e) {
    e = Array.isArray(e) ? e : [e];
    let r = 0;
    for (var _iterator16 = _createForOfIteratorHelperLoose(e), _step16; !(_step16 = _iterator16()).done;) {
      const s = _step16.value;
      if (typeof s == "string") {
        r += h.get(this).size + _(this, s).size + b(this, s).size + b(this).size;
        continue;
      }
      typeof s < "u" && g(s), r += h.get(this).size;
      for (var _iterator17 = _createForOfIteratorHelperLoose(E.get(this).values()), _step17; !(_step17 = _iterator17()).done;) {
        const o = _step17.value;
        r += o.size;
      }
      for (var _iterator18 = _createForOfIteratorHelperLoose(y.get(this).values()), _step18; !(_step18 = _iterator18()).done;) {
        const o = _step18.value;
        r += o.size;
      }
    }
    return r;
  };
  _proto.bindMethods = function bindMethods(e, r) {
    if (typeof e != "object" || e === null) throw new TypeError("`target` must be an object");
    r = H(r);
    for (var _iterator19 = _createForOfIteratorHelperLoose(r), _step19; !(_step19 = _iterator19()).done;) {
      const s = _step19.value;
      if (e[s] !== void 0) throw new Error(`The property \`${s}\` already exists on \`target\``);
      Object.defineProperty(e, s, {
        enumerable: !1,
        value: this[s].bind(this)
      });
    }
  };
  (0, _createClass2.default)(m, null, [{
    key: "isDebugEnabled",
    get: function get() {
      if (typeof process != "object") return x;
      const _ref3 = process || {
          env: {}
        },
        e = _ref3.env;
      return e.DEBUG === "emittery" || e.DEBUG === "*" || x;
    },
    set: function set(e) {
      x = e;
    }
  }]);
  return m;
}();
const Q = Object.getOwnPropertyNames(m.prototype).filter(t => t !== "constructor");
Object.defineProperty(m, "listenerAdded", {
  value: k,
  writable: !1,
  enumerable: !0,
  configurable: !1
});
Object.defineProperty(m, "listenerRemoved", {
  value: A,
  writable: !1,
  enumerable: !0,
  configurable: !1
});
var L = m;
function J(t) {
  return typeof t == "object" && t !== null && "message" in t && typeof t.message == "string";
}
function X(t) {
  if (J(t)) return t;
  try {
    return new Error(JSON.stringify(t));
  } catch (_unused2) {
    return new Error(String(t));
  }
}
function v(t) {
  return X(t).message;
}
var Z = Object.defineProperty,
  K = (t, e, r) => e in t ? Z(t, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : t[e] = r,
  N = (t, e, r) => (K(t, typeof e != "symbol" ? e + "" : e, r), r),
  ee = /* @__PURE__ */(t => (t.automation = "automation", t.test = "test", t.vbc = "vbc", t.video = "video", t.voice = "voice", t))(ee || {});
exports.VonageSourceType = ee;
const re = "hlg.tokbox.com/prod/logging/vcp_webrtc",
  te = "https://",
  se = 1e4;
let S;
const oe = new Uint8Array(16);
function ie() {
  if (!S && (S = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !S)) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return S(oe);
}
const f = [];
for (let t = 0; t < 256; ++t) f.push((t + 256).toString(16).slice(1));
function ne(t, e) {
  if (e === void 0) {
    e = 0;
  }
  return (f[t[e + 0]] + f[t[e + 1]] + f[t[e + 2]] + f[t[e + 3]] + "-" + f[t[e + 4]] + f[t[e + 5]] + "-" + f[t[e + 6]] + f[t[e + 7]] + "-" + f[t[e + 8]] + f[t[e + 9]] + "-" + f[t[e + 10]] + f[t[e + 11]] + f[t[e + 12]] + f[t[e + 13]] + f[t[e + 14]] + f[t[e + 15]]).toLowerCase();
}
const ae = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto),
  z = {
    randomUUID: ae
  };
function ce(t, e, r) {
  if (z.randomUUID && !e && !t) return z.randomUUID();
  t = t || {};
  const s = t.random || (t.rng || ie)();
  if (s[6] = s[6] & 15 | 64, s[8] = s[8] & 63 | 128, e) {
    r = r || 0;
    for (let o = 0; o < 16; ++o) e[r + o] = s[o];
    return e;
  }
  return ne(s);
}
function W(t, e) {
  _globalThis.vonage || (_globalThis.vonage = {}), _globalThis.vonage.workerizer || (_globalThis.vonage.workerizer = {});
  let r = _globalThis.vonage.workerizer;
  return r[t] || (r[t] = e), r[t];
}
const p = W("globals", {});
var d = /* @__PURE__ */(t => (t.INIT = "INIT", t.FORWARD = "FORWARD", t.TERMINATE = "TERMINATE", t.GLOBALS_SYNC = "GLOBALS_SYNC", t))(d || {});
function j(t) {
  return [ImageBitmap, ReadableStream, WritableStream].some(e => t instanceof e);
}
let fe = 0;
function le(t, e, r, s, o) {
  const i = fe++;
  return t.postMessage({
    id: i,
    type: e,
    functionName: r,
    args: s
  }, s.filter(n => j(n))), new Promise(n => {
    o == null || o.set(i, n);
  });
}
function w(t, e) {
  const r = t.id,
    s = t.type,
    o = Array.isArray(e) ? e : [e];
  postMessage({
    id: r,
    type: s,
    result: e
  }, o.filter(i => j(i)));
}
const G = W("workerized", {});
function B() {
  return typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope;
}
function ue() {
  return _ue.apply(this, arguments);
}
function _ue() {
  _ue = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee21() {
    var t, e, _G$e$workerContext, r, s;
    return _regenerator.default.wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          if (!B()) {
            _context21.next = 4;
            break;
          }
          w({
            type: d.GLOBALS_SYNC
          }, p);
          _context21.next = 8;
          break;
        case 4:
          t = [];
          for (e in G) {
            _G$e$workerContext = G[e].workerContext, r = _G$e$workerContext.worker, s = _G$e$workerContext.resolvers;
            r && t.push(le(r, d.GLOBALS_SYNC, "", [p], s));
          }
          _context21.next = 8;
          return Promise.all(t);
        case 8:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));
  return _ue.apply(this, arguments);
}
function P(t, e) {
  if (Array.isArray(e)) e.splice(0, e.length);else if (typeof e == "object") for (const r in e) delete e[r];
  for (const r in t) Array.isArray(t[r]) ? (e[r] = [], P(t[r], e[r])) : typeof t[r] == "object" ? (e[r] = {}, P(t[r], e[r])) : e[r] = t[r];
}
function he(_x7, _x8) {
  return _he.apply(this, arguments);
}
function _he() {
  _he = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee22(t, e) {
    var r, s;
    return _regenerator.default.wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          r = t.functionName, s = t.args;
          if (e.instance) {
            _context22.next = 3;
            break;
          }
          throw "instance not initialized";
        case 3:
          if (r) {
            _context22.next = 5;
            break;
          }
          throw "missing function name to call";
        case 5:
          if (e.instance[r]) {
            _context22.next = 7;
            break;
          }
          throw `undefined function [${r}] in class ${e.instance.constructor.workerId}`;
        case 7:
          _context22.t0 = w;
          _context22.t1 = t;
          _context22.next = 11;
          return e.instance[r](...(s != null ? s : []));
        case 11:
          _context22.t2 = _context22.sent;
          (0, _context22.t0)(_context22.t1, _context22.t2);
        case 13:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }));
  return _he.apply(this, arguments);
}
const pe = W("registeredWorkers", {});
function de(t, e) {
  if (!t.args) throw "Missing className while initializing worker";
  const _t$args = t.args,
    r = _t$args[0],
    s = _t$args[1],
    o = pe[r];
  if (o) e.instance = new o(t.args.slice(1));else throw `unknown worker class ${r}`;
  P(s, p), w(t, typeof e.instance !== void 0);
}
function me(_x9, _x10) {
  return _me.apply(this, arguments);
}
function _me() {
  _me = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee23(t, e) {
    var r, s;
    return _regenerator.default.wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          r = t.args;
          if (e.instance) {
            _context23.next = 3;
            break;
          }
          throw "instance not initialized";
        case 3:
          _context23.t0 = e.instance.terminate;
          if (!_context23.t0) {
            _context23.next = 8;
            break;
          }
          _context23.next = 7;
          return e.instance.terminate(...(r != null ? r : []));
        case 7:
          s = _context23.sent;
        case 8:
          w(t, s);
        case 9:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }));
  return _me.apply(this, arguments);
}
function ge(t) {
  if (!t.args) throw "Missing globals while syncing";
  P(t.args[0], p), w(t, {});
}
function _e() {
  const t = {};
  onmessage = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(e) {
      var r;
      return _regenerator.default.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            r = e.data;
            _context7.t0 = r.type;
            _context7.next = _context7.t0 === d.INIT ? 4 : _context7.t0 === d.FORWARD ? 6 : _context7.t0 === d.TERMINATE ? 8 : _context7.t0 === d.GLOBALS_SYNC ? 10 : 12;
            break;
          case 4:
            de(r, t);
            return _context7.abrupt("break", 12);
          case 6:
            he(r, t);
            return _context7.abrupt("break", 12);
          case 8:
            me(r, t);
            return _context7.abrupt("break", 12);
          case 10:
            ge(r);
            return _context7.abrupt("break", 12);
          case 12:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function onmessage(_x11) {
      return _ref4.apply(this, arguments);
    };
  }();
}
B() && _e();
function ye(t, e) {
  return p[t] || (p[t] = e), [() => p[t], /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(r) {
      return _regenerator.default.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            p[t] = r;
            _context8.next = 3;
            return ue();
          case 3:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function (_x12) {
      return _ref5.apply(this, arguments);
    };
  }()];
}
function be(t, e) {
  return ye(t, e);
}
const _be = be("metadata"),
  we = _be[0],
  Te = _be[1];
function Ce(t) {
  Te(t);
}
function C() {
  return we();
}
let D = /*#__PURE__*/function () {
  function D(e) {
    N(this, "uuid", ce()), this.config = e;
  }
  var _proto2 = D.prototype;
  _proto2.send = /*#__PURE__*/function () {
    var _send = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(e) {
      var r, s, o, _ref6, i, n, c, u;
      return _regenerator.default.wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _ref6 = (r = C()) != null ? r : {}, i = _ref6.appId, n = _ref6.sourceType;
            if (!(!i || !n)) {
              _context9.next = 3;
              break;
            }
            return _context9.abrupt("return", "metadata missing");
          case 3:
            c = new AbortController(), u = setTimeout(() => c.abort(), se);
            _context9.next = 6;
            return ((o = (s = this.config) == null ? void 0 : s.fetch) != null ? o : fetch)(this.getUrl(), {
              method: "POST",
              headers: this.getHeaders(),
              body: JSON.stringify(this.buildReport(e)),
              signal: c.signal
            });
          case 6:
            clearTimeout(u);
            return _context9.abrupt("return", "success");
          case 8:
          case "end":
            return _context9.stop();
        }
      }, _callee9, this);
    }));
    function send(_x13) {
      return _send.apply(this, arguments);
    }
    return send;
  }();
  _proto2.getUrl = function getUrl() {
    var e;
    let r = (e = C().proxyUrl) != null ? e : te;
    return r += (r.at(-1) === "/" ? "" : "/") + re, r;
  };
  _proto2.getHeaders = function getHeaders() {
    return {
      "Content-Type": "application/json"
    };
  };
  _proto2.buildReport = function buildReport(e) {
    const r = C();
    return Object.assign({
      guid: this.uuid
    }, e, {
      applicationId: r.appId,
      timestamp: Date.now(),
      proxyUrl: r.proxyUrl,
      source: r.sourceType
    });
  };
  return D;
}();
const R = "2.0.3";
let Se = /*#__PURE__*/function () {
  function Se(e) {
    a(this, "frameTransformedCount", 0);
    a(this, "frameFromSourceCount", 0);
    a(this, "startAt", 0);
    a(this, "reporter");
    this.config = e, this.reporter = new D(e);
  }
  var _proto3 = Se.prototype;
  _proto3.onFrameFromSource = /*#__PURE__*/function () {
    var _onFrameFromSource = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10() {
      return _regenerator.default.wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            this.frameFromSourceCount++;
          case 1:
          case "end":
            return _context10.stop();
        }
      }, _callee10, this);
    }));
    function onFrameFromSource() {
      return _onFrameFromSource.apply(this, arguments);
    }
    return onFrameFromSource;
  }();
  _proto3.onFrameTransformed = /*#__PURE__*/function () {
    var _onFrameTransformed = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(e, r) {
      var s, o, i, n, c, u, M;
      return _regenerator.default.wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            if (e === void 0) {
              e = {};
            }
            if (r === void 0) {
              r = !1;
            }
            this.startAt === 0 && (this.startAt = Date.now()), this.frameTransformedCount++;
            s = this.startAt, o = this.frameTransformedCount, i = this.frameFromSourceCount, n = Date.now(), c = (n - s) / 1e3, u = o / c, M = i / c;
            return _context11.abrupt("return", r || this.frameTransformedCount >= this.config.loggingIntervalFrameCount ? (this.frameFromSourceCount = 0, this.frameTransformedCount = 0, this.startAt = n, this.reporter.config = this.config, this.reporter.send(Object.assign({}, this.config.report, {
              variation: "QoS",
              fps: M,
              transformedFps: u,
              framesTransformed: o
            }, e))) : "success");
          case 5:
          case "end":
            return _context11.stop();
        }
      }, _callee11, this);
    }));
    function onFrameTransformed(_x14, _x15) {
      return _onFrameTransformed.apply(this, arguments);
    }
    return onFrameTransformed;
  }();
  (0, _createClass2.default)(Se, [{
    key: "fps",
    get: function get() {
      const e = this.startAt,
        r = this.frameFromSourceCount,
        o = (Date.now() - e) / 1e3;
      return r / o;
    }
  }]);
  return Se;
}();
var Ee = /* @__PURE__ */(t => (t.FPS_DROP = "fps_drop", t))(Ee || {}),
  Re = /* @__PURE__ */(t => (t.start = "start", t.transform = "transform", t.flush = "flush", t))(Re || {}),
  F = /* @__PURE__ */(t => (t.pipeline_ended = "pipeline_ended", t.pipeline_ended_with_error = "pipeline_ended_with_error", t.pipeline_started = "pipeline_started", t.pipeline_started_with_error = "pipeline_started_with_error", t.pipeline_restarted = "pipeline_restarted", t.pipeline_restarted_with_error = "pipeline_restarted_with_error", t))(F || {});
exports.PipelineInfoData = F;
exports.ErrorFunction = Re;
exports.WarningType = Ee;
const ke = 500,
  Ae = 0.8;
let Pe = /*#__PURE__*/function (_L) {
  (0, _inheritsLoose2.default)(Pe, _L);
  function Pe(r, s) {
    var _this2;
    _this2 = _L.call(this) || this;
    a((0, _assertThisInitialized2.default)(_this2), "reporter_", new D());
    a((0, _assertThisInitialized2.default)(_this2), "reporterQos_", new Se({
      loggingIntervalFrameCount: ke,
      report: {
        version: R
      }
    }));
    a((0, _assertThisInitialized2.default)(_this2), "transformerType_");
    a((0, _assertThisInitialized2.default)(_this2), "transformer_");
    a((0, _assertThisInitialized2.default)(_this2), "shouldStop_");
    a((0, _assertThisInitialized2.default)(_this2), "isFlashed_");
    a((0, _assertThisInitialized2.default)(_this2), "mediaTransformerQosReportStartTimestamp_");
    a((0, _assertThisInitialized2.default)(_this2), "videoHeight_");
    a((0, _assertThisInitialized2.default)(_this2), "videoWidth_");
    a((0, _assertThisInitialized2.default)(_this2), "trackExpectedRate_");
    a((0, _assertThisInitialized2.default)(_this2), "index_");
    a((0, _assertThisInitialized2.default)(_this2), "controller_");
    _this2.index_ = s, _this2.transformer_ = r, _this2.shouldStop_ = !1, _this2.isFlashed_ = !1, _this2.mediaTransformerQosReportStartTimestamp_ = 0, _this2.videoHeight_ = 0, _this2.videoWidth_ = 0, _this2.trackExpectedRate_ = -1, _this2.transformerType_ = "Custom", "getTransformerType" in r && (_this2.transformerType_ = r.getTransformerType()), _this2.report({
      variation: "Create"
    });
    return _this2;
  }
  var _proto4 = Pe.prototype;
  _proto4.setTrackExpectedRate = function setTrackExpectedRate(r) {
    this.trackExpectedRate_ = r;
  };
  _proto4.start = /*#__PURE__*/function () {
    var _start = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12(r) {
      var o;
      return _regenerator.default.wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            if (!(this.controller_ = r, this.transformer_ && typeof this.transformer_.start == "function")) {
              _context12.next = 11;
              break;
            }
            _context12.prev = 1;
            _context12.next = 4;
            return this.transformer_.start(r);
          case 4:
            _context12.next = 11;
            break;
          case 6:
            _context12.prev = 6;
            _context12.t0 = _context12["catch"](1);
            this.report({
              message: l.errors.transformer_start,
              variation: "Error",
              error: v(_context12.t0)
            });
            o = {
              eventMetaData: {
                transformerIndex: this.index_
              },
              error: _context12.t0,
              function: "start"
            };
            this.emit("error", o);
          case 11:
          case "end":
            return _context12.stop();
        }
      }, _callee12, this, [[1, 6]]);
    }));
    function start(_x16) {
      return _start.apply(this, arguments);
    }
    return start;
  }();
  _proto4.transform = /*#__PURE__*/function () {
    var _transform = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13(r, s) {
      var o, i, n, c, M, u;
      return _regenerator.default.wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            if (!(this.mediaTransformerQosReportStartTimestamp_ === 0 && (this.mediaTransformerQosReportStartTimestamp_ = Date.now()), r instanceof VideoFrame && (this.videoHeight_ = (o = r == null ? void 0 : r.displayHeight) != null ? o : 0, this.videoWidth_ = (i = r == null ? void 0 : r.displayWidth) != null ? i : 0), this.reporterQos_.onFrameFromSource(), this.transformer_)) {
              _context13.next = 17;
              break;
            }
            if (!this.shouldStop_) {
              _context13.next = 5;
              break;
            }
            console.warn("[Pipeline] flush from transform"), r.close(), this.flush(s), s.terminate();
            _context13.next = 17;
            break;
          case 5:
            _context13.prev = 5;
            _context13.next = 8;
            return (c = (n = this.transformer_).transform) == null ? void 0 : c.call(n, r, s);
          case 8:
            this.reportQos();
            _context13.next = 16;
            break;
          case 11:
            _context13.prev = 11;
            _context13.t0 = _context13["catch"](5);
            this.report({
              message: l.errors.transformer_transform,
              variation: "Error",
              error: v(_context13.t0)
            });
            M = {
              eventMetaData: {
                transformerIndex: this.index_
              },
              error: _context13.t0,
              function: "transform"
            };
            this.emit("error", M);
          case 16:
            if (this.trackExpectedRate_ != -1 && this.trackExpectedRate_ * Ae > this.reporterQos_.fps) {
              u = {
                eventMetaData: {
                  transformerIndex: this.index_
                },
                warningType: "fps_drop",
                dropInfo: {
                  requested: this.trackExpectedRate_,
                  current: this.reporterQos_.fps
                }
              };
              this.emit("warn", u);
            }
          case 17:
          case "end":
            return _context13.stop();
        }
      }, _callee13, this, [[5, 11]]);
    }));
    function transform(_x17, _x18) {
      return _transform.apply(this, arguments);
    }
    return transform;
  }();
  _proto4.flush = /*#__PURE__*/function () {
    var _flush = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14(r) {
      var o;
      return _regenerator.default.wrap(function _callee14$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            if (!(this.transformer_ && typeof this.transformer_.flush == "function" && !this.isFlashed_)) {
              _context14.next = 12;
              break;
            }
            this.isFlashed_ = !0;
            _context14.prev = 2;
            _context14.next = 5;
            return this.transformer_.flush(r);
          case 5:
            _context14.next = 12;
            break;
          case 7:
            _context14.prev = 7;
            _context14.t0 = _context14["catch"](2);
            this.report({
              message: l.errors.transformer_flush,
              variation: "Error",
              error: v(_context14.t0)
            });
            o = {
              eventMetaData: {
                transformerIndex: this.index_
              },
              error: _context14.t0,
              function: "flush"
            };
            this.emit("error", o);
          case 12:
            this.reportQos(!0), this.report({
              variation: "Delete"
            });
          case 13:
          case "end":
            return _context14.stop();
        }
      }, _callee14, this, [[2, 7]]);
    }));
    function flush(_x19) {
      return _flush.apply(this, arguments);
    }
    return flush;
  }();
  _proto4.stop = function stop() {
    console.log("[Pipeline] Stop stream."), this.controller_ && (this.flush(this.controller_), this.controller_.terminate()), this.shouldStop_ = !0;
  };
  _proto4.report = function report(r) {
    this.reporter_.send(Object.assign({
      version: R,
      action: "MediaTransformer",
      transformerType: this.transformerType_
    }, r));
  };
  _proto4.reportQos = function reportQos(r) {
    if (r === void 0) {
      r = !1;
    }
    this.reporterQos_.config = Object.assign({}, this.reporterQos_.config), this.reporterQos_.onFrameTransformed({
      version: R,
      action: "MediaTransformer",
      transformerType: this.transformerType_,
      videoWidth: this.videoWidth_,
      videoHeight: this.videoHeight_
    }, r);
  };
  return Pe;
}(L);
let Me = /*#__PURE__*/function (_L2) {
  (0, _inheritsLoose2.default)(Me, _L2);
  function Me(r) {
    var _this3;
    _this3 = _L2.call(this) || this;
    a((0, _assertThisInitialized2.default)(_this3), "transformers_");
    a((0, _assertThisInitialized2.default)(_this3), "trackExpectedRate_");
    _this3.transformers_ = [], _this3.trackExpectedRate_ = -1;
    for (let s = 0; s < r.length; s++) {
      let o = new Pe(r[s], s);
      o.on("error", i => {
        _this3.emit("error", i);
      }), o.on("warn", i => {
        _this3.emit("warn", i);
      }), _this3.transformers_.push(o);
    }
    return _this3;
  }
  var _proto5 = Me.prototype;
  _proto5.setTrackExpectedRate = function setTrackExpectedRate(r) {
    this.trackExpectedRate_ = r;
    for (var _iterator20 = _createForOfIteratorHelperLoose(this.transformers_), _step20; !(_step20 = _iterator20()).done;) {
      let s = _step20.value;
      s.setTrackExpectedRate(this.trackExpectedRate_);
    }
  };
  _proto5.start = /*#__PURE__*/function () {
    var _start2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17(r, s) {
      var _this4 = this;
      var o, _iterator21, _step21, i;
      return _regenerator.default.wrap(function _callee17$(_context17) {
        while (1) switch (_context17.prev = _context17.next) {
          case 0:
            if (!(!this.transformers_ || this.transformers_.length === 0)) {
              _context17.next = 3;
              break;
            }
            console.log("[Pipeline] No transformers.");
            return _context17.abrupt("return");
          case 3:
            _context17.prev = 3;
            o = r;
            for (_iterator21 = _createForOfIteratorHelperLoose(this.transformers_); !(_step21 = _iterator21()).done;) {
              i = _step21.value;
              r = r.pipeThrough(new TransformStream(i));
            }
            r.pipeTo(s).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15() {
              return _regenerator.default.wrap(function _callee15$(_context15) {
                while (1) switch (_context15.prev = _context15.next) {
                  case 0:
                    console.log("[Pipeline] Setup.");
                    _context15.next = 3;
                    return s.abort();
                  case 3:
                    _context15.next = 5;
                    return o.cancel();
                  case 5:
                    _this4.emit("pipelineInfo", "pipeline_ended");
                  case 6:
                  case "end":
                    return _context15.stop();
                }
              }, _callee15);
            }))).catch( /*#__PURE__*/function () {
              var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16(i) {
                return _regenerator.default.wrap(function _callee16$(_context16) {
                  while (1) switch (_context16.prev = _context16.next) {
                    case 0:
                      r.cancel().then(() => {
                        console.log("[Pipeline] Shutting down streams after abort.");
                      }).catch(n => {
                        console.error("[Pipeline] Error from stream transform:", n);
                      });
                      _context16.next = 3;
                      return s.abort(i);
                    case 3:
                      _context16.next = 5;
                      return o.cancel(i);
                    case 5:
                      _this4.emit("pipelineInfo", "pipeline_ended_with_error");
                    case 6:
                    case "end":
                      return _context16.stop();
                  }
                }, _callee16);
              }));
              return function (_x22) {
                return _ref8.apply(this, arguments);
              };
            }());
            _context17.next = 13;
            break;
          case 9:
            _context17.prev = 9;
            _context17.t0 = _context17["catch"](3);
            this.emit("pipelineInfo", "pipeline_started_with_error"), this.destroy();
            return _context17.abrupt("return");
          case 13:
            this.emit("pipelineInfo", "pipeline_started"), console.log("[Pipeline] Pipeline started.");
          case 14:
          case "end":
            return _context17.stop();
        }
      }, _callee17, this, [[3, 9]]);
    }));
    function start(_x20, _x21) {
      return _start2.apply(this, arguments);
    }
    return start;
  }();
  _proto5.destroy = /*#__PURE__*/function () {
    var _destroy = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee18() {
      var _iterator22, _step22, r;
      return _regenerator.default.wrap(function _callee18$(_context18) {
        while (1) switch (_context18.prev = _context18.next) {
          case 0:
            console.log("[Pipeline] Destroying Pipeline.");
            for (_iterator22 = _createForOfIteratorHelperLoose(this.transformers_); !(_step22 = _iterator22()).done;) {
              r = _step22.value;
              r.stop();
            }
          case 2:
          case "end":
            return _context18.stop();
        }
      }, _callee18, this);
    }));
    function destroy() {
      return _destroy.apply(this, arguments);
    }
    return destroy;
  }();
  return Me;
}(L);
let Oe = /*#__PURE__*/function (_L3) {
  (0, _inheritsLoose2.default)(Oe, _L3);
  function Oe() {
    var _this5;
    _this5 = _L3.call(this) || this;
    a((0, _assertThisInitialized2.default)(_this5), "reporter_");
    a((0, _assertThisInitialized2.default)(_this5), "pipeline_");
    a((0, _assertThisInitialized2.default)(_this5), "transformers_");
    a((0, _assertThisInitialized2.default)(_this5), "readable_");
    a((0, _assertThisInitialized2.default)(_this5), "writable_");
    a((0, _assertThisInitialized2.default)(_this5), "trackExpectedRate_");
    _this5.reporter_ = new D(), _this5.trackExpectedRate_ = -1, _this5.report({
      variation: "Create"
    });
    return _this5;
  }
  var _proto6 = Oe.prototype;
  _proto6.setTrackExpectedRate = function setTrackExpectedRate(r) {
    this.trackExpectedRate_ = r, this.pipeline_ && this.pipeline_.setTrackExpectedRate(this.trackExpectedRate_);
  };
  _proto6.transform = function transform(r, s) {
    return this.readable_ = r, this.writable_ = s, this.transformInternal();
  };
  _proto6.transformInternal = function transformInternal() {
    var _this6 = this;
    return new Promise( /*#__PURE__*/function () {
      var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee19(r, s) {
        var o;
        return _regenerator.default.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              if (!(!_this6.transformers_ || _this6.transformers_.length === 0)) {
                _context19.next = 3;
                break;
              }
              _this6.report({
                message: l.errors.transformer_none,
                variation: "Error"
              }), s("[MediaProcessor] Need to set transformers.");
              return _context19.abrupt("return");
            case 3:
              if (_this6.readable_) {
                _context19.next = 6;
                break;
              }
              _this6.report({
                variation: "Error",
                message: l.errors.readable_null
              }), s("[MediaProcessor] Readable is null.");
              return _context19.abrupt("return");
            case 6:
              if (_this6.writable_) {
                _context19.next = 9;
                break;
              }
              _this6.report({
                variation: "Error",
                message: l.errors.writable_null
              }), s("[MediaProcessor] Writable is null.");
              return _context19.abrupt("return");
            case 9:
              o = !1;
              _this6.pipeline_ && (o = !0, _this6.pipeline_.clearListeners(), _this6.pipeline_.destroy()), _this6.pipeline_ = new Me(_this6.transformers_), _this6.pipeline_.on("warn", i => {
                _this6.emit("warn", i);
              }), _this6.pipeline_.on("error", i => {
                _this6.emit("error", i);
              }), _this6.pipeline_.on("pipelineInfo", i => {
                o && (i === "pipeline_started" ? i = F.pipeline_restarted : i === "pipeline_started_with_error" && (i = F.pipeline_restarted_with_error)), _this6.emit("pipelineInfo", i);
              }), _this6.trackExpectedRate_ != -1 && _this6.pipeline_.setTrackExpectedRate(_this6.trackExpectedRate_), _this6.pipeline_.start(_this6.readable_, _this6.writable_).then(() => {
                r();
              }).catch(i => {
                s(i);
              });
            case 11:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }));
      return function (_x23, _x24) {
        return _ref9.apply(this, arguments);
      };
    }());
  };
  _proto6.setTransformers = function setTransformers(r) {
    return this.report({
      variation: "Update",
      message: l.updates.transformer_new
    }), this.transformers_ = r, this.readable_ && this.writable_ ? this.transformInternal() : Promise.resolve();
  };
  _proto6.destroy = function destroy() {
    var _this7 = this;
    return new Promise( /*#__PURE__*/function () {
      var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee20(r) {
        return _regenerator.default.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _this7.pipeline_ && _this7.pipeline_.destroy(), _this7.report({
                variation: "Delete"
              }), r();
            case 1:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }));
      return function (_x25) {
        return _ref10.apply(this, arguments);
      };
    }());
  };
  _proto6.report = function report(r) {
    this.reporter_.send(Object.assign({
      version: R,
      action: "MediaProcessor"
    }, r));
  };
  return Oe;
}(L);
exports.MediaProcessor = Oe;
let xe = /*#__PURE__*/function () {
  function xe() {
    a(this, "processor_");
    a(this, "generator_");
    this.processor_ = null, this.generator_ = null;
  }
  var _proto7 = xe.prototype;
  _proto7.init = function init(e) {
    return new Promise((r, s) => {
      try {
        this.processor_ = new MediaStreamTrackProcessor(e);
      } catch (o) {
        console.log(`[InsertableStreamHelper] MediaStreamTrackProcessor failed: ${o}`), s(o);
      }
      try {
        e.kind === "audio" ? this.generator_ = new MediaStreamTrackGenerator({
          kind: "audio"
        }) : e.kind === "video" ? this.generator_ = new MediaStreamTrackGenerator({
          kind: "video"
        }) : s("kind not supported");
      } catch (o) {
        console.log(`[InsertableStreamHelper] MediaStreamTrackGenerator failed: ${o}`), s(o);
      }
      r();
    });
  };
  _proto7.getReadable = function getReadable() {
    return this.processor_.readable;
  };
  _proto7.getWriteable = function getWriteable() {
    return this.generator_.writable;
  };
  _proto7.getProccesorTrack = function getProccesorTrack() {
    return this.generator_;
  };
  return xe;
}();
let Fe = /*#__PURE__*/function () {
  function Fe(e) {
    a(this, "insertableStreamHelper_");
    a(this, "mediaProcessor_");
    this.insertableStreamHelper_ = new xe(), this.mediaProcessor_ = e;
  }
  var _proto8 = Fe.prototype;
  _proto8.setTrack = function setTrack(e) {
    return new Promise((r, s) => {
      this.insertableStreamHelper_.init(e).then(() => {
        this.mediaProcessor_.transform(this.insertableStreamHelper_.getReadable(), this.insertableStreamHelper_.getWriteable()).then(() => {
          r(this.insertableStreamHelper_.getProccesorTrack());
        }).catch(o => {
          s(o);
        });
      }).catch(o => {
        s(o);
      });
    });
  };
  _proto8.destroy = function destroy() {
    return new Promise((e, r) => {
      this.mediaProcessor_ ? this.mediaProcessor_.destroy().then(() => {
        e();
      }).catch(s => {
        r(s);
      }) : r("no processor");
    });
  };
  return Fe;
}();
exports.MediaProcessorConnector = Fe;